import React from 'react'
import './styles.scss'

function EmptyScreen () {
  const count = Array.from({ length: 3 }, (v, k) => k)

  return (
    <div className='emptyScreen'>
      <p>Select one channel</p>
      <header className='emptyScreen__header'>
        <span />
      </header>
      <div className='emptyScreen__messages'>
        {count.map((k, i) => (
          <div className='emptyScreen__message' key={i}>
            <h3 className='emptyScreen__nickname'>
              <span />
              <span className='emptyScreen__hour'>
                <span />
              </span>
            </h3>
            <p />
          </div>
        ))}
      </div>
      <footer className='emptyScreen__footer'>
        <div />
      </footer>
    </div>
  )
}

export default EmptyScreen
